// Modules
import { Button } from '@dasa-health/components-react'
import { useSignUp } from 'context'
import { useSignUpAnaytics } from 'hooks/useSignUpAnaytics'
import React, { useEffect } from 'react'

interface Props {
    isCounter: boolean
    onResendToken: () => void
    onResendTokenWhatsapp?: () => void
    isDestinationMobile: boolean
    count: number
    dataTestButton?: string
    dataTestCounter?: string
    onMountResentAnalytics?: () => void
    isOtp?: boolean
}

export const ResendToken: React.FC<Props> = ({
    onResendToken,
    onResendTokenWhatsapp,
    count,
    dataTestButton,
    dataTestCounter,
    isCounter,
    isDestinationMobile,
    onMountResentAnalytics,
    isOtp = false,
}) => {
    useEffect(() => {
        if (!isCounter && isDestinationMobile) {
            onMountResentAnalytics && onMountResentAnalytics()
        }
    }, [isCounter, isDestinationMobile, onMountResentAnalytics])

    const counterLabel = `${count < 10 ? `0${count}` : count}s`

    const { hasMounted, personalData, passwords, hasSeenFirstStep } = useSignUp()
    const shouldRedirect = !personalData?.cpf || !personalData.biologicalSex || !passwords?.password || !hasSeenFirstStep

    const { dispatchAnalyticsEvent } = useSignUpAnaytics({
        shouldCall: hasMounted && !shouldRedirect,
    })
    if (isCounter) {
        return (
            <p className="footer__paragraph" data-testid={dataTestCounter}>
                Você pode pedir um novo código em <strong>{counterLabel}</strong>
            </p>
        )
    }

    if (!isDestinationMobile) {
        return (
            <Button
                className="footer__button-resend-token"
                data-testid={dataTestButton}
                onClick={onResendToken}
                size="default"
                type="button"
                variant="primary"
            >
                Reenviar código
            </Button>
        )
    }

    return (
        <>
            <p className="footer__paragraph footer__paragraph--ask-for-action">
                Ainda não recebeu o código? Escolha a melhor opção para reenviar:
            </p>
            <Button
                className="footer__button-resend-token"
                data-testid={dataTestButton}
                onClick={() => {
                    onResendToken()
                    !isOtp && dispatchAnalyticsEvent('confirmTokenOnOpenResent', { itemText: 'Receber por SMS' })
                }}
                size="default"
                type="button"
                variant="primary"
            >
                Receber por SMS
            </Button>
            {onResendTokenWhatsapp && (
                <Button
                    className="footer__button-resend-token"
                    data-testid={`${dataTestButton}-whatsapp`}
                    onClick={() => {
                        onResendTokenWhatsapp()
                        !isOtp && dispatchAnalyticsEvent('confirmTokenOnOpenResent', { itemText: 'Receber por WhatsApp' })
                    }}
                    size="default"
                    type="button"
                    variant="secondary"
                >
                    Receber por Whatsapp
                </Button>
            )}
        </>
    )
}
